var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-msg-code"},[_c('el-button',{staticClass:"btn",attrs:{"type":"primary"},on:{"click":_vm.sendMsg}},[_vm._v("\n    "+_vm._s(_vm.time == 0 ? '获取验证码' : (_vm.time + "s"))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }